import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faEye, faPlus, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './GastosData.css';
import baseURL from '../../url';
import moneda from '../../moneda';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default function GastosData() {
    // Función para formatear moneda
    const formatearMoneda = (valor) => {
        return `${moneda} ${parseFloat(valor).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
    };
    const [gastos, setGastos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalDetalleVisible, setModalDetalleVisible] = useState(false);
    const [gastoActual, setGastoActual] = useState({});
    const [categorias, setCategorias] = useState([]);
    const [proveedores, setProveedores] = useState([]);

    // Filtros
    const [filtroTexto, setFiltroTexto] = useState('');
    const [filtroFechaInicio, setFiltroFechaInicio] = useState('');
    const [filtroFechaFin, setFiltroFechaFin] = useState('');
    const [filtroProveedor, setFiltroProveedor] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');

    // Campos del formulario
    const [monto, setMonto] = useState('');
    const [fecha, setFecha] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [idCategoriaGasto, setIdCategoriaGasto] = useState('');
    const [idProveedor, setIdProveedor] = useState('');
    const [referencia, setReferencia] = useState('');

    useEffect(() => {
        cargarGastos();
        cargarCategorias();
        cargarProveedores();
    }, []);

    useEffect(() => {
        aplicarFiltros();
    }, [filtroTexto, filtroFechaInicio, filtroFechaFin, filtroProveedor, filtroCategoria]);

    const cargarGastos = () => {
        fetch(`${baseURL}/gastosGet.php`)
            .then(response => response.json())
            .then(data => {
                setGastos(data.gastos || []);
            })
            .catch(error => console.error('Error al cargar gastos:', error));
    };

    const aplicarFiltros = () => {
        const params = new URLSearchParams();
        if (filtroTexto) params.append('q', filtroTexto);
        if (filtroFechaInicio) params.append('date_from', filtroFechaInicio);
        if (filtroFechaFin) params.append('date_to', filtroFechaFin);
        if (filtroProveedor) params.append('proveedor_id', filtroProveedor);
        if (filtroCategoria) params.append('categoria_id', filtroCategoria);

        fetch(`${baseURL}/gastosGet.php?${params.toString()}`)
            .then(response => response.json())
            .then(data => setGastos(data.gastos || []))
            .catch(error => console.error('Error al aplicar filtros:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGastosGet.php`)
            .then(response => response.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarProveedores = () => {
        fetch(`${baseURL}/inventarioProveedoresGet.php`)
            .then(response => response.json())
            .then(data => setProveedores(data.proveedores || []))
            .catch(error => console.error('Error al cargar proveedores:', error));
    };

    const abrirModalNuevo = () => {
        setGastoActual({});
        limpiarFormulario();
        // Establecer fecha actual como default
        const hoy = new Date();
        const fechaFormato = hoy.toISOString().slice(0, 16);
        setFecha(fechaFormato);
        setModalVisible(true);
    };

    const abrirModalEditar = (gasto) => {
        setGastoActual(gasto);
        setMonto(gasto.monto || '');
        // Convertir fecha de MySQL a formato datetime-local
        const fechaFormato = gasto.fecha ? gasto.fecha.replace(' ', 'T').slice(0, 16) : '';
        setFecha(fechaFormato);
        setDescripcion(gasto.descripcion || '');
        setIdCategoriaGasto(gasto.idCategoriaGasto || '');
        setIdProveedor(gasto.idProveedor || '');
        setReferencia(gasto.referencia || '');
        setModalVisible(true);
    };

    const abrirModalDetalle = (gasto) => {
        setGastoActual(gasto);
        setModalDetalleVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setModalDetalleVisible(false);
        limpiarFormulario();
    };

    const limpiarFormulario = () => {
        setMonto('');
        setFecha('');
        setDescripcion('');
        setIdCategoriaGasto('');
        setIdProveedor('');
        setReferencia('');
    };

    const guardarGasto = () => {
        if (!monto || !fecha || !descripcion) {
            toast.error('Monto, fecha y descripción son obligatorios');
            return;
        }

        if (parseFloat(monto) <= 0) {
            toast.error('El monto debe ser mayor a 0');
            return;
        }

        if (gastoActual.idGasto) {
            // Editar
            const payload = {
                monto: parseFloat(monto),
                fecha: fecha.replace('T', ' ') + ':00',
                descripcion,
                idCategoriaGasto: idCategoriaGasto || null,
                idProveedor: idProveedor || null,
                referencia
            };

            fetch(`${baseURL}/gastosPut.php?idGasto=${gastoActual.idGasto}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Actualizado!', data.mensaje, 'success');
                        cargarGastos();
                        cerrarModal();
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    toast.error('Error al actualizar gasto');
                });
        } else {
            // Crear
            const formData = new FormData();
            formData.append('monto', parseFloat(monto));
            formData.append('fecha', fecha.replace('T', ' ') + ':00');
            formData.append('descripcion', descripcion);
            formData.append('idCategoriaGasto', idCategoriaGasto || '');
            formData.append('idProveedor', idProveedor || '');
            formData.append('referencia', referencia);
            // formData.append('registradoPor', usuarioActual); // Si implementas sistema de usuarios

            fetch(`${baseURL}/gastosPost.php`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Éxito!', data.mensaje, 'success');
                        cargarGastos();
                        cerrarModal();
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    toast.error('Error al registrar gasto');
                });
        }
    };

    const eliminarGasto = (idGasto) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Esta acción no se puede revertir",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/gastosDelete.php?idGasto=${idGasto}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            toast.error(data.error);
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarGastos();
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        toast.error('Error al eliminar gasto');
                    });
            }
        });
    };

    const limpiarFiltros = () => {
        setFiltroTexto('');
        setFiltroFechaInicio('');
        setFiltroFechaFin('');
        setFiltroProveedor('');
        setFiltroCategoria('');
    };

    const exportarExcel = () => {
        const datosExportar = gastos.map(g => ({
            'ID': g.idGasto,
            'Monto': g.monto,
            'Fecha': g.fecha,
            'Descripción': g.descripcion,
            'Categoría': g.nombreCategoria || 'Sin categoría',
            'Proveedor': g.nombreProveedor || 'Sin proveedor',
            'Referencia': g.referencia || '',
            'Registrado por': g.nombreUsuario || ''
        }));

        const ws = XLSX.utils.json_to_sheet(datosExportar);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Gastos');
        XLSX.writeFile(wb, `Gastos_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    const exportarPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.text('Registro de Gastos', 14, 20);
        
        const tableData = gastos.map(g => [
            g.idGasto,
            formatearMoneda(g.monto),
            g.fecha,
            g.descripcion.substring(0, 30) + (g.descripcion.length > 30 ? '...' : ''),
            g.nombreCategoria || 'Sin categoría',
            g.nombreProveedor || 'Sin proveedor'
        ]);

        doc.autoTable({
            startY: 30,
            head: [['ID', 'Monto', 'Fecha', 'Descripción', 'Categoría', 'Proveedor']],
            body: tableData,
        });

        doc.save(`Gastos_${new Date().toISOString().slice(0, 10)}.pdf`);
    };

    const formatearFecha = (fechaISO) => {
        if (!fechaISO) return '';
        const fecha = new Date(fechaISO);
        return fecha.toLocaleString('es-ES', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="gastosDataContainer">
            <ToastContainer />
            
            <div className="gastosHeader">
                <h2>Registro de Gastos</h2>
                <div className="gastosHeaderActions">
                    <button className="btnExportar" onClick={exportarExcel} title="Exportar a Excel">
                        <FontAwesomeIcon icon={faFileExcel} /> Excel
                    </button>
                    <button className="btnExportar" onClick={exportarPDF} title="Exportar a PDF">
                        <FontAwesomeIcon icon={faFilePdf} /> PDF
                    </button>
                    <button className="btnAgregar" onClick={abrirModalNuevo}>
                        <FontAwesomeIcon icon={faPlus} /> Registrar Gasto
                    </button>
                </div>
            </div>

            {/* Filtros */}
            <div className="gastosFiltros">
                <input
                    type="text"
                    placeholder="Buscar por descripción o referencia..."
                    value={filtroTexto}
                    onChange={(e) => setFiltroTexto(e.target.value)}
                    className="filtroInput"
                />
                <input
                    type="date"
                    placeholder="Fecha inicio"
                    value={filtroFechaInicio}
                    onChange={(e) => setFiltroFechaInicio(e.target.value)}
                    className="filtroInput"
                />
                <input
                    type="date"
                    placeholder="Fecha fin"
                    value={filtroFechaFin}
                    onChange={(e) => setFiltroFechaFin(e.target.value)}
                    className="filtroInput"
                />
                <select
                    value={filtroCategoria}
                    onChange={(e) => setFiltroCategoria(e.target.value)}
                    className="filtroInput"
                >
                    <option value="">Todas las categorías</option>
                    {categorias.map(cat => (
                        <option key={cat.idCategoriaGasto} value={cat.idCategoriaGasto}>
                            {cat.nombre}
                        </option>
                    ))}
                </select>

                <button className="btnLimpiarFiltros" onClick={limpiarFiltros}>
                    Limpiar Filtros
                </button>
            </div>

            {/* Tabla */}
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Monto</th>
                            <th>Fecha</th>
                            <th>Descripción</th>
                            <th>Categoría</th>

                            <th>Referencia</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gastos.length > 0 ? (
                            gastos.map(gasto => (
                                <tr key={gasto.idGasto}>
                                    <td>{gasto.idGasto}</td>
                                    <td>{formatearMoneda(gasto.monto)}</td>
                                    <td>{formatearFecha(gasto.fecha)}</td>
                                    <td title={gasto.descripcion}>
                                        {gasto.descripcion.length > 50 
                                            ? gasto.descripcion.substring(0, 50) + '...' 
                                            : gasto.descripcion}
                                    </td>
                                    <td>{gasto.nombreCategoria || 'Sin categoría'}</td>

                                    <td>{gasto.referencia || '-'}</td>
                                    <td>
                                        <button 
                                            className="btnAccion btnVer" 
                                            onClick={() => abrirModalDetalle(gasto)}
                                            title="Ver detalle"
                                        >
                                            <FontAwesomeIcon icon={faEye} />
                                        </button>
                                        <button 
                                            className="btnAccion btnEditar" 
                                            onClick={() => abrirModalEditar(gasto)}
                                            title="Editar"
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button 
                                            className="btnAccion btnEliminar" 
                                            onClick={() => eliminarGasto(gasto.idGasto)}
                                            title="Eliminar"
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center', padding: '2rem' }}>
                                    No hay gastos registrados
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal Formulario */}
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>{gastoActual.idGasto ? 'Editar Gasto' : 'Registrar Gasto'}</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>
                        <div className="modal-body">
                            <div className="formGroup">
                                <label>Monto *</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={monto}
                                    onChange={(e) => setMonto(e.target.value)}
                                    placeholder="0.00"
                                />
                            </div>
                            <div className="formGroup">
                                <label>Fecha y hora *</label>
                                <input
                                    type="datetime-local"
                                    value={fecha}
                                    onChange={(e) => setFecha(e.target.value)}
                                />
                            </div>
                            <div className="formGroup">
                                <label>Descripción *</label>
                                <textarea
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                    rows="4"
                                    placeholder="Describe el gasto..."
                                ></textarea>
                            </div>
                            <div className="formGroup">
                                <label>Categoría</label>
                                <select
                                    value={idCategoriaGasto}
                                    onChange={(e) => setIdCategoriaGasto(e.target.value)}
                                >
                                    <option value="">Seleccionar categoría</option>
                                    {categorias.map(cat => (
                                        <option key={cat.idCategoriaGasto} value={cat.idCategoriaGasto}>
                                            {cat.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="formGroup">
                                <label>Referencia / Nota</label>
                                <input
                                    type="text"
                                    value={referencia}
                                    onChange={(e) => setReferencia(e.target.value)}
                                    placeholder="Ej: Factura #1234, Recibo, etc."
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btnCancelar" onClick={cerrarModal}>
                                Cancelar
                            </button>
                            <button className="btnGuardar" onClick={guardarGasto}>
                                {gastoActual.idGasto ? 'Actualizar' : 'Guardar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Detalle */}
            {modalDetalleVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>Detalle del Gasto</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>
                        <div className="modal-body">
                            <div className="detalleGasto">
                                <p><strong>ID:</strong> {gastoActual.idGasto}</p>
                                <p><strong>Monto:</strong> {formatearMoneda(gastoActual.monto)}</p>
                                <p><strong>Fecha:</strong> {formatearFecha(gastoActual.fecha)}</p>
                                <p><strong>Descripción:</strong> {gastoActual.descripcion}</p>
                                <p><strong>Categoría:</strong> {gastoActual.nombreCategoria || 'Sin categoría'}</p>

                                <p><strong>Referencia:</strong> {gastoActual.referencia || 'Sin referencia'}</p>
                                {gastoActual.nombreUsuario && (
                                    <p><strong>Registrado por:</strong> {gastoActual.nombreUsuario}</p>
                                )}
                                <p><strong>Creado el:</strong> {formatearFecha(gastoActual.createdAt)}</p>
                                {gastoActual.updatedAt && gastoActual.updatedAt !== gastoActual.createdAt && (
                                    <p><strong>Última actualización:</strong> {formatearFecha(gastoActual.updatedAt)}</p>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btnCancelar" onClick={cerrarModal}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

